import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useMatchMedia } from '@alfalab/core-components-mq/esm';
import { InputDesktop } from './desktop/Component.desktop.js';
import { InputMobile } from './mobile/Component.mobile.js';

var Input = forwardRef(function (_a, ref) {
    var _b = _a.breakpoint, breakpoint = _b === void 0 ? 1024 : _b, defaultMatchMediaValue = _a.defaultMatchMediaValue, restProps = __rest(_a, ["breakpoint", "defaultMatchMediaValue"]);
    var query = "(min-width: ".concat(breakpoint, "px)");
    var isDesktop = useMatchMedia(query, defaultMatchMediaValue)[0];
    var Component = isDesktop ? InputDesktop : InputMobile;
    return React.createElement(Component, __assign({ ref: ref }, restProps));
});

export { Input };
